// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"b24e92a6","563":"db61b20b","564":"804b2a1d","727":"e8717fe9"}[chunkId] + ".chunk.js";
};